import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import PublicNav from '../components/PublicNav';
import Footer from '../components/Footer';

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const { login } = useAuth();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    const result = await login(formData.email, formData.password);
    setMessage(result.message);
    setLoading(false);

    if (result.success) {
      // Check if user is judge
      if (formData.email.includes('judge')) {
        window.location.href = '/judge';
      } else {
        window.location.href = '/admin';
      }
    }
  };

  return (
    <div className="min-h-screen bg-[#05339c]">
      <PublicNav />
      <div className="flex items-center justify-center py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8 bg-dark-blue p-8 rounded-2xl shadow-2xl border-2 border-yellow">
          <div>
            <h2 className="mt-6 text-center text-3xl font-semibold text-white">
              تسجيل دخول <span className="text-yellow">المنظمين</span>
            </h2>
            <p className="mt-2 text-center text-sm text-yellow">
              هاكاثون قمة - لوحة التحكم
            </p>
          </div>
          
          <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          {message && (
            <div className={`p-4 rounded-lg ${
              message.includes('نجح') ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
            }`}>
              {message}
            </div>
          )}
          
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label htmlFor="email" className="sr-only">
                البريد الإلكتروني
              </label>
              <input
dir="ltr"                id="email"
                name="email"
                type="email"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 bg-blue/20 border border-yellow placeholder-gray-400 text-white rounded-t-md focus:outline-none focus:ring-yellow focus:border-yellow focus:z-10 sm:text-sm"
                placeholder="البريد الإلكتروني"
                value={formData.email}
                onChange={handleInputChange}
              />
            </div>
            <div>
              <label htmlFor="password" className="sr-only">
                كلمة المرور
              </label>
              <input
dir="ltr"                id="password"
                name="password"
                type="password"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 bg-blue/20 border border-yellow placeholder-gray-400 text-white rounded-b-md focus:outline-none focus:ring-yellow focus:border-yellow focus:z-10 sm:text-sm"
                placeholder="كلمة المرور"
                value={formData.password}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div>
            <button
              type="submit"
              disabled={loading}
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm rounded-md text-dark-blue bg-yellow hover:bg-yellow/80 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow disabled:opacity-50 transition-all duration-300 font-bold shadow-lg"
            >
              {loading ? 'جاري تسجيل الدخول...' : 'تسجيل الدخول'}
            </button>
          </div>

          <div className="text-center">
            <a
              href="/"
              className="font-medium text-yellow hover:text-yellow/80"
            >
              العودة للصفحة الرئيسية
            </a>
          </div>
          </form>

          {/* Admin credentials info */}
          <div className="mt-8 p-4 bg-blue/20 border border-yellow rounded-lg">
            <h3 className="text-sm font-medium text-yellow mb-2">معلومات تسجيل الدخول:</h3>
            <p className="text-xs text-white">
              استخدم البريد الإلكتروني وكلمة المرور الخاصة بحساب المنظم
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Login;
